import React from 'react'
import analytics from 'global/AnalyticsData'
import WistiaEmbed from './WistiaEmbed'
import ShareIcons from 'components/ShareIcons'
import { parseVideoIDs } from './util'
import './VideoStep.scss'

// step engagement: when a user watches 3 seconds of a video
// points awarded: when a user watches 3 seconds of a video

const VideoStep = ({
  brk = {},
  step,
  onEngage = function () {},
  onAwardPoints = function () {},
  skipButton,
  nextStepButton,
  handleInstantWinEvent = function () {},
}) => {
  const shareClickHandler = args => {
    console.log('share click handler')

    analytics.stepEvent('step_interaction_video_embedded_video_share', step, {
      context_id: args.platform,
      context: args.platform,
    })

    handleInstantWinEvent({
      eventName: 'share_click',
      context: { stepId: step.id, ...args },
    })
  }

  const videoIDArray = parseVideoIDs(step.videoId)

  const socialShareComponent = step.socialShareOn && (
    <ShareIcons
      facebookShare={step.facebookShare}
      twitterShare={step.twitterShare}
      pinterestShare={step.pinterestShare}
      emailShare={step.emailShare}
      emailConfig={{
        subject: step.shareEmailSubject,
        body: step.shareEmailBody,
      }}
      copyShare={step.copyShare}
      whatsappShare={step.whatsappShare}
      onShareClick={shareClickHandler}
      shareUrl={`${process.env.BASE_URL}/video-share/${brk.permalink}/${videoIDArray[0]}/`}
    />
  )

  // viewed == thumbnail shown, NOT played
  const handleVideoViewed = videoId => {
    analytics.stepEvent('step_interaction_video_embedded_video_view', step, {
      result_id: videoId,
      result: videoId,
    })
  }

  const handleVideoPlayed = videoId => {
    analytics.stepEvent('step_interaction_video_embedded_video_play', step, {
      result_id: videoId,
      result: videoId,
    })
  }

  // user watched enough to be considered complete
  const handleVideoWatched = videoId => {
    analytics.stepEvent(
      'step_interaction_video_embedded_video_complete',
      step,
      {
        result_id: videoId,
        result: videoId,
      },
    )
    onEngage()
    onAwardPoints()
  }

  return (
    <>
      <section className="video-step video-step-3">
        <div
          className={`step-content with-shadow ${
            brk?.navigationType === 'TOP' ? 'top-navigation' : ''
          }`}
        >
          <div className="video-step-inside">
            {step.headline && (
              <h2
                className="video-step--headline step-content__title"
                dangerouslySetInnerHTML={{ __html: step.headline }}
              ></h2>
            )}
            {step.topText && (
              <h3
                className="video-step--subhead"
                dangerouslySetInnerHTML={{ __html: step.topText }}
              ></h3>
            )}
            <WistiaEmbed
              videoIDs={videoIDArray}
              handleVideoViewed={handleVideoViewed}
              handleVideoPlayed={handleVideoPlayed}
              handleVideoWatched={handleVideoWatched}
            />
            {socialShareComponent}
          </div>
          {skipButton}
          {nextStepButton}
        </div>
      </section>
    </>
  )
}

export default VideoStep
